import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useCustomer } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomer();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const returnTo = sessionStorage.getItem("rr_return_to") || "/account";
    sessionStorage.removeItem("rr_return_to");
    (async () => {
      try {
        const { data } = await api.post("/customer/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", location.pathname);
        toast.success(`Welcome, ${data.name?.split(" ")[0] || "rider"}!`);
        navigate(returnTo, { replace: true, state: { user: data } });
      } catch (e) {
        window.history.replaceState(null, "", "/");
        toast.error(e.response?.data?.detail || "Sign-in failed, please try again");
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center" data-testid="auth-callback">
      <p className="font-mono text-xs uppercase tracking-widest text-ink/50">Signing you in…</p>
    </div>
  );
}
